import Icon from 'veui/components/Icon'
import { IconCheckDesktop } from 'dls-icons-vue'

Icon.register('check-desktop', IconCheckDesktop)
